export interface ArquivoTempData {
  blob: Blob;
  nomeArquivo: string;
  mimeType: string;
  tamanhoBytes: number;
}

let _arquivo: ArquivoTempData | null = null;

export const setArquivoTemp = (data: ArquivoTempData) => { _arquivo = data; };
export const getArquivoTemp = () => _arquivo;
export const clearArquivoTemp = () => { _arquivo = null; };
